export function initPaymentForm (container, { errorClass = 'error' } = {}) {
    return; 
    
    const cardInput = container.querySelector('.cc-number');
    const expInput = container.querySelector('.cc-exp');
    const cvvInput = container.querySelector('.cc-cvv');

    if (cardInput) {
        cardInput.addEventListener('input', () => {
            let v = cardInput.value.replace(/\D/g, '');
            v = v.substring(0, 16);
            cardInput.value = v.replace(/(\d{4})(?=\d)/g, '$1 ').trim();
        });
    }

    if (expInput) {
        expInput.addEventListener('input', () => {
            let v = expInput.value.replace(/\D/g, '');
            if (v.length > 4) v = v.substring(0, 4);
            if (v.length >= 3) {
                expInput.value = v.substring(0, 2) + '/' + v.substring(2);
            } else {
                expInput.value = v;
            }
        });
    }

    if (cvvInput) {
        cvvInput.addEventListener('input', () => {
            cvvInput.value = cvvInput.value.replace(/\D/g, '').substring(0, 4);
        });
    }
}
